module.exports = __webpack_public_path__ + "media/all-inclusive.70f381fa.jpg";